module.exports = __webpack_public_path__ + "static/media/railcarMasterSheet.b1a51309.svg";